import { render, staticRenderFns } from "./productExtraPrice.vue?vue&type=template&id=49a7e864&scoped=true&"
import script from "./productExtraPrice.vue?vue&type=script&lang=js&"
export * from "./productExtraPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a7e864",
  null
  
)

export default component.exports